export enum AirwallexTransferStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
    Initiated = 'initiated',
    Blocked = 'blocked',
}
